const isVariantPublished = (variant)=>variant.isPublished !== false
;

export { isVariantPublished };
//# sourceMappingURL=is-variant-published.js.map
